// src/styles/theme.ts
// Centralized MUI theme definition.
import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: { main: '#1976d2' },
    secondary: { main: '#dc004e' },
    background: { default: '#f4f6f8', paper: '#ffffff' },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 14, // Base font size in px (MUI/Material Design default)
    h4: { fontSize: '1.5rem', fontWeight: 700 }, // Adjusted for consistency
    h5: { fontSize: '1.25rem', fontWeight: 700 },
    h6: { fontSize: '1rem', fontWeight: 600 },
    body1: { fontSize: '0.875rem' }, // 14px - MUI default for body text
    body2: { fontSize: '0.8125rem' }, // 13px - MUI default for secondary text
    button: { textTransform: 'none', fontWeight: 500 }, // Consistent with button overrides
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          overflowX: 'hidden', // Prevent horizontal scroll on the root element
        },
        body: {
          overflowX: 'hidden', // Prevent horizontal scroll on the body
          width: '100%',
          boxSizing: 'border-box',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          padding: '10px 20px',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});
